import { SoundCloudVersionDetailsFormData } from 'app/components/Releases/SoundCloudVersionDetailsForm/types';
import {
  fetchReleaseVersionEffect,
  updateReleaseVersionEffect,
} from 'app/store/Releases/effects';
import { ReleaseType } from 'types/releases';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getReleaseGuid,
  getReleaseVersion,
} from 'app/store/Releases/selectors';

export const useUpdateVersion = (releaseType?: ReleaseType) => {
  const dispatch = useAppDispatch();
  const releaseVersion = useAppSelector(getReleaseVersion);
  const releaseGuid = useAppSelector(getReleaseGuid);

  const updateVersion = async (
    formData: Partial<SoundCloudVersionDetailsFormData>,
    options?: { refetchVersion?: boolean }
  ) => {
    if (!releaseType || releaseType === ReleaseType.LABEL) {
      return;
    }

    await dispatch(
      updateReleaseVersionEffect({
        formData,
        releaseType,
      })
    ).unwrap();

    if (options?.refetchVersion) {
      await dispatch(
        fetchReleaseVersionEffect({
          releaseGuid,
          versionGuid: releaseVersion?.metadata.guid as string,
        })
      );
    }
  };

  return { updateVersion };
};
